"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    className: "fill-primary"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.55,7.87H11v4.28h1.15a4,4,0,0,0,2.32-.62h0a1.8,1.8,0,0,0,.86-1.59,1.8,1.8,0,0,0-.66-1.56A4,4,0,0,0,12.55,7.87Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.17,0H.83A.84.84,0,0,0,0,.84V23.17A.83.83,0,0,0,.83,24H23.17a.83.83,0,0,0,.83-.83V.84A.84.84,0,0,0,23.17,0ZM15.79,12.92a5.22,5.22,0,0,1-3.5,1H11.18v4.34H8.6V6.06h3.89a5.19,5.19,0,0,1,3.38,1A3.7,3.7,0,0,1,17,9.86,4,4,0,0,1,15.79,12.92Z"
  })), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.3",
    y: "11.21",
    width: "23.41",
    height: "1.57",
    transform: "translate(-4.97 12) rotate(-45)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,1.57A10.43,10.43,0,1,1,1.57,12,10.44,10.44,0,0,1,12,1.57M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  }));
};

exports["default"] = _default;